import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import MinWageForm from '../components/MinWageForm';
import { saveMinWage } from '../actions/users';

class MinWageFormContainer extends Component {
    saveMinWage = (formProps) => {
        return this.props.saveMinWage(formProps);
    }

    render() {
        return (
            <MinWageForm
                saveMinWage={this.saveMinWage}
            />
        );
    }
}

export default connect(null, { saveMinWage })(MinWageFormContainer);



/** WEBPACK FOOTER **
 ** ./src/containers/MinWageFormContainer.js
 **/